import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import localize from 'helpers/translator/localize'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Confirm from 'views/confirm/confirm'
import onboardingGuideActions from 'redux/actions/onboardingGuideActions'

const OnboardingGuideConfirm = props => (
	<Confirm
		alertTitle={localize('onboardingGuide_dismiss_confirm_title')}
		alertMessage={localize('onboardingGuide_dismiss_confirm_message')}
		btOne={localize('global_cancel')}
		btTwo={localize('onboardingGuide_dismiss_confirm_dismiss')}
		actionOne={props.actions.cancel}
		actionTwo={props.actions.dismiss}
		closeButton={false}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		dismiss: onboardingGuideActions.confirmDismiss,
		cancel: onboardingGuideActions.cancelDismiss,
	}, dispatch)
}

OnboardingGuideConfirm.propTypes = {
	actions: PropTypes.shape({
		dismiss: PropTypes.func.isRequired,
		cancel: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(OnboardingGuideConfirm)

export { OnboardingGuideConfirm }
